import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => {
  return {
    paymentNumber: {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightBold,
    },
    verifyButton: {
      textTransform: 'none !important',
      textAlign: 'right',
      fontSize: '12px !important',
      fontWeight: '500 !important',
      padding: '2px 6px',
      minWidth: 'auto',
      '&:hover': {
        backgroundColor: 'rgba(52, 131, 250, 0.1)',
      },
    },
  };
});
